export default {
  "STATISTICS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statistics"])},
  "TIME_FRAMES": {
    "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["week"])},
    "month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["month"])},
    "year": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["year"])}
  }
}